import React, { useState } from 'react';
import { DetailsList, DetailsListLayoutMode, SelectionMode, ConstrainMode, IColumn, Spinner, SpinnerSize, TooltipHost, Link } from '@fluentui/react';
import { renderDate } from '../../helpers/HelperMethods';
import DeleteRedirect from './SiteEditElements/DeleteRedirect';

const SiteRedirects = ({site, refresh}) => {
    const [isLoading, setIsLoading] = useState(false);

    const columns: IColumn[] = [
        {
            key: 'oldUrl',
            name: 'Url',
            fieldName: 'oldUrl',
            minWidth: 400, 
            maxWidth: 700,
            isResizable: true,
            onRender: (item) => {
                return <TooltipHost content={item.oldUrl}>
                        <Link target='_blank' href={item.oldUrl} disabled={item.deleted}>{item.oldUrl}</Link>
                    </TooltipHost>
            }
        },
        {
            key: 'created',
            name: 'Created',
            fieldName: 'created',
            minWidth: 80,
            maxWidth: 100,
            isResizable: true,
            data: 'number',
            onRender: (item) => {
                return <span>{renderDate(item.created)}</span>;
            },
            isPadded: true
        },
        {
            key: 'deleted',
            name: 'Deleted',
            fieldName: 'deleted',
            minWidth: 80,
            maxWidth: 100,
            isResizable: true,
            data: 'number',
            onRender: (item) => {
                return <span>{renderDate(item.deleted)}</span>;
            },
            isPadded: true
        },
        {
            key: 'actions',
            name: 'Actions',
            minWidth: 50, 
            maxWidth: 200, 
            isResizable: true,
            onRender: (item) => {
                return item.deleted ? <div></div> : <DeleteRedirect redirectId={item.id} siteId={site.id} setLoading={setIsLoading} refresh={refresh}/>
            }
        },
    ]


    return(
        <div>
            <div style={containerStyles}>
                <DetailsList 
                    items={site.siteRedirects}
                    columns={columns}
                    layoutMode={DetailsListLayoutMode.justified}
                    isHeaderVisible={true}
                    selectionMode={SelectionMode.none}
                    styles={{root: {width: '100%'}}}
                    constrainMode={ConstrainMode.horizontalConstrained}
                    />
            </div>
            <div style={spinnerContainerStyles}>
                {
                    isLoading && 
                    <Spinner size={SpinnerSize.medium} />
                }
            </div>
        </div>
    );
};

const containerStyles = {
    padding: "10px"
}

const spinnerContainerStyles = {
    padding: "20px"
}

export default SiteRedirects;


// WEBPACK FOOTER //
// ./src/components/EditSite/SiteRedirects.js